import React from 'react';
import { DamageWaiverSignatureCanvas } from './DamageWaiverSignatureCanvas';
import { DamageWaiverSignatureImage } from './DamageWaiverSignatureImage';

export const DamageWaiverSignature = ({ edit, ...props }) =>
  edit ? <DamageWaiverSignatureCanvas {...props} /> : <DamageWaiverSignatureImage {...props} />;
